module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.embeddedModules || []), function(embeddedModule, index) {
    return [_c('embedded-module-component', {
      attrs: {
        "state": _vm.state,
        "config": Object.keys(embeddedModule.config || {}).length > 0 ? embeddedModule.config : {},
        "event-bus": _vm.eventBus,
        "icon-class": embeddedModule.iconClass,
        "row": _vm.row,
        "query": Object.keys(embeddedModule.query || {}).length > 0 ? embeddedModule.query : {},
        "target": embeddedModule.target,
        "title": embeddedModule.title,
        "url": embeddedModule.url
      }
    })]
  }), _vm._v(" "), (_vm.displayValue) ? _c('span', [_vm._v(_vm._s(_vm.row[_vm.column.data]))]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4cd57d12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/EmbeddedModulesComponent.vue
// module id = 1284
// module chunks = 2